// eslint-disable-next-line import/prefer-default-export
export enum ForgottenPasswordScreen {
  ENTER_EMAIL,
  EMAIL_SENT,
}
